import React from 'react'
import { useReactiveVar } from '@apollo/client'
import { calculatorVar } from '../../../apollo/reactive-vars'
import type {
  BoreholeFieldContainerInput,
  LocalGridFragment,
} from '../../../generated/graphql'
import { Printable } from '../../common/Printable'
import { SystemContainerBoreholeField } from '../../system-container/borehole-field/SystemContainerBoreholeField'
import { useLocalGrids } from '../../../local-grid/use-local-grids'

type Props = {
  localGrid: LocalGridFragment
}

export function LocalGridBoreholeFieldTab({
  localGrid,
}: Props): React.ReactElement {
  const calculator = useReactiveVar(calculatorVar)
  const { updateLocalGridBoreholeField } = useLocalGrids()

  const localGridCalculator = calculator?.findLocalGrid(localGrid.id)

  if (!localGridCalculator) {
    return <></>
  }

  const providers = localGridCalculator.getProviders()

  const updateContainer = async (input: BoreholeFieldContainerInput) => {
    await updateLocalGridBoreholeField(localGrid.id, input)
  }

  return (
    <Printable>
      <SystemContainerBoreholeField
        container={localGrid}
        updateContainer={updateContainer}
        providers={providers}
      />
    </Printable>
  )
}
